export const EXTERNAL_PREFIXES = [
  'http://',
  'https://',
  'mailto:',
  'tel:',
] as const;
